module.exports = __webpack_public_path__ + "dcb87651659657c0baddbd3314368814.png";